import { render, staticRenderFns } from "./SinistreHistory.vue?vue&type=template&id=35c7b948"
import script from "./SinistreHistory.vue?vue&type=script&lang=js"
export * from "./SinistreHistory.vue?vue&type=script&lang=js"
import style0 from "./SinistreHistory.vue?vue&type=style&index=0&id=35c7b948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports